import { createStore } from 'redux';
import rootReducer from '../store/reducers/reducers';

export default createStore(rootReducer);
